import type { ReactNode } from "react";

import { cn } from "../../lib/cn";

type BadgeVariant = "default" | "secondary" | "success" | "warning" | "error" | "outline";

type BadgeProps = {
	variant?: BadgeVariant;
	children: ReactNode;
	className?: string;
};

const variantStyles: Record<BadgeVariant, string> = {
	default: "bg-pastel-vibrant-blue/10 text-pastel-vibrant-blue",
	secondary: "bg-pastel-light-gray text-pastel-gray",
	success: "bg-green-100 text-green-700",
	warning: "bg-yellow-100 text-yellow-700",
	error: "bg-red-100 text-red-700",
	outline: "border border-pastel-border text-pastel-gray",
};

export function Badge({ variant = "default", children, className }: BadgeProps) {
	return (
		<span
			className={cn(
				"inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium",
				variantStyles[variant],
				className
			)}
		>
			{children}
		</span>
	);
}
